module.exports = __webpack_public_path__ + "static/media/hjälm-min.7040adf0.png";